export interface Config {
    readonly carbonApiBaseUrl: string;
    readonly auth: {
        readonly audience: string;
        readonly authority: string;
        readonly clientId: string;
    };
    readonly organizationLogoUrl?: string;
    readonly partnerLogoUrl?: string;
    readonly loginLogoUrl?: string;
}

declare global {
    interface Window {
        __CONFIG__: {
            CARBON_API_BASE_URL: string;
            AUTH: {
                AUTHORITY: string;
                CLIENT_ID: string;
                AUDIENCE: string;
            };
            ORGANIZATION_LOGO_URL?: string;
            PARTNER_LOGO_URL?: string;
            LOGIN_LOGO_URL?: string;
        };
    }
}

const config: Config = {
    carbonApiBaseUrl: window.__CONFIG__.CARBON_API_BASE_URL,
    auth: {
        authority: window.__CONFIG__.AUTH.AUTHORITY,
        clientId: window.__CONFIG__.AUTH.CLIENT_ID,
        audience: window.__CONFIG__.AUTH.AUDIENCE
    },
    organizationLogoUrl: window.__CONFIG__?.ORGANIZATION_LOGO_URL,
    partnerLogoUrl: window.__CONFIG__?.PARTNER_LOGO_URL,
    loginLogoUrl: window.__CONFIG__?.LOGIN_LOGO_URL
};

export default config;